export default __webpack_public_path__ + "506da8141e2390bfeb3f076714313c9e.svg";